import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateAwardJudgeStatus: (
  fetchContext: FetchContext,
  awardJudgeId: number,
  status: boolean,
  accessToken?: string,
) => Promise<void> = (fetchContext, awardJudgeId, status, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/award-judges/${awardJudgeId}/status`,
  {
    method: 'PUT',
    body: JSON.stringify({ status }),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update award judge status'));
